package com.macrofocus.eflux.network

import com.macrofocus.eflux.network.line.PowerLineData
import com.macrofocus.eflux.network.logical.LogicalBranchId
import com.macrofocus.eflux.network.logical.LogicalBusId
import com.macrofocus.eflux.network.substation.PowerSubstationData

open class PowerNetworkCapability(
    val substationData: (LogicalBusId) -> PowerSubstationData,
    val lineData: (LogicalBranchId) -> PowerLineData
) : NetworkCapability